export const STORYBOARD_REQUEST_ID_COOKIE = 'SSBID';
export const STORYBOARD_SCENE_REQUEST_ID_COOKIE = 'SSBCID';

export const MUSIC_RECOMMENDATIONS_COUNT = 4;
export const MUSIC_RECOMMENDATIONS_MIN_PAGE = 0;
export const MUSIC_RECOMMENDATIONS_MAX_PAGE = 5;
